import React from 'react';
import { Sparkles, Utensils, Moon, Heart } from 'lucide-react';
export function TransformationSection() {
  return <section className="bg-gradient-to-b from-black to-[#111111] py-24 px-4 text-center pt-[40px] pb-[40px]" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-169">
          Imagine a Morning{' '}
          <span className="text-orange-500" data-id="element-170">Without Hissing</span>
        </h2>

        <div className="prose prose-lg prose-invert mx-auto" data-id="element-171">
          <ul className="list-none space-y-4 text-left mt-6 not-prose" data-id="element-172">
            <li className="flex items-start gap-4" data-id="element-173">
              <div className="p-2 bg-orange-500/10 rounded-full mt-0.5 shrink-0" data-id="element-174">
                <Utensils className="w-5 h-5 text-orange-400" data-id="element-175" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-176">
                Both cats are eating{' '}
                <span className="text-white font-semibold" data-id="element-177">side-by-side</span>,
                calm and unbothered.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-178">
              <div className="p-2 bg-orange-500/10 rounded-full mt-0.5 shrink-0" data-id="element-179">
                <Moon className="w-5 h-5 text-orange-400" data-id="element-180" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-181">
                You find them{' '}
                <span className="text-white font-semibold" data-id="element-182">
                  napping on the same rug
                </span>
                , peaceful and close.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-183">
              <div className="p-2 bg-orange-500/10 rounded-full mt-0.5 shrink-0" data-id="element-184">
                <Heart className="w-5 h-5 text-orange-400" data-id="element-185" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-186">
                <span className="text-white font-semibold" data-id="element-187">
                  No stress. No guilt. No fear.
                </span>{' '}
                Just the happy, multi-cat family you always dreamed of.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}